/**
 * Controla o playback do caminhão na rota realizada do mapa
 *
 * @author adalto.junior
 * Date: 13/05/2014
 *
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Greenmile.Toolbar.Map.RoutePlay = function (toolbarSelector, map, options) {

    var _toolbarSelector = toolbarSelector;
    var routePlay = this;
    var sourceData;
    var coordGf;
    var beforeStartPlay;
    var afterChangeDate;

    if (options && options.sourceSessionData) {

        sourceData = options.sourceSessionData;
        coordGf = new Greenmile.Coordinates.GeneralFunctions(sourceData);

        if (options.routePlay) {

            if (options.routePlay.beforeStartPlay) {
                beforeStartPlay = options.routePlay.beforeStartPlay;
            }

            if (options.routePlay.afterChangeDate) {
                afterChangeDate = options.routePlay.afterChangeDate;
            }
        }

    }

    var updateTruckPosition = function (latlng) {
        sourceData.player.marker.setLatLng(latlng);
    };

    this.setRangeToFields = function () {

        var currentMarkerIndex = sourceData.player.currentMarkerIndex || 0;
        var lastMarkerIndex = sourceData.player.lastMarkerIndex;

        if (currentMarkerIndex !== -1 && sourceData.coordinates && sourceData.coordinates.size()) {
            const coordinates = sourceData.coordinates;
            const initialDate = coordinates.at(currentMarkerIndex).attributes.date;
            const finalDate = coordinates.at(lastMarkerIndex).attributes.date;
            const initialDateFormatted = Monet.Format.DateTime.formatToLocale(initialDate);
            const finalDateFormatted = Monet.Format.DateTime.formatToLocale(finalDate);

            $(_toolbarSelector + " input[name='routePlay_initialDate']").val(initialDateFormatted);
            $(_toolbarSelector + " #mini_routePlay_initialDate").val(initialDateFormatted);
            $(_toolbarSelector + " input[name='routePlay_finalDate']").val(finalDateFormatted);
            $(_toolbarSelector + " #mini_routePlay_finalDate").val(finalDateFormatted);
        }
    };

    this.addCoordsRange = function () {
        const extraOptions = {
            onClose: function (e)  {
                const date = arguments[0];
                const name = this.getAttribute('name');
                if (name === 'routePlay_initialDate') {
                    routePlay.setDateRangeToNamespace(date, undefined);
                } else if (name === 'routePlay_finalDate') {
                    routePlay.setDateRangeToNamespace(undefined, date);
                }

                if (afterChangeDate) {
                    afterChangeDate(true);
                }

            },
            beforeShow: () => {},
        };

        const date = new Monet.Date.GeneralFunctions();
        date.setDateTimePicker(`${_toolbarSelector} .dateTimePicker`, extraOptions);

    };

    this.addFormFilterListener = function () {

        $(_toolbarSelector + " .routePlayGo").off("click");
        $(_toolbarSelector + " .routePlayGo").on("click", function () {

            if (sourceData.canMakeCoordinates) {

                var callback = function () {

                    if ($(_toolbarSelector + " input[name='routePlay_initialDate']").val() === "" && $(_toolbarSelector + " input[name='routePlay_finalDate']").val() === "") {
                        routePlay.setRangeToFields();
                    }

                };
                routePlay.togglePlayer(callback, undefined);

            }

        });

        $(_toolbarSelector + " .routePlayGoToLast").off("click");
        $(_toolbarSelector + " .routePlayGoToLast").on("click", function () {

            if (sourceData.canMakeCoordinates) {

                sourceData.player.lastMarkerIndex = 0;
                sourceData.player.playerIndex = 0;

                if (sourceData.coordinates && sourceData.coordinates.size()) {
                    sourceData.player.lastMarkerIndex = sourceData.coordinates.size() - 1;
                }

                $(_toolbarSelector + " .dateTimePicker").val("");

                routePlay.setDateRangeToNamespace(
                    $(_toolbarSelector + "  input[name='routePlay_initialDate']").val(),
                    $(_toolbarSelector + "  input[name='routePlay_finalDate']").val()
                );

                $(_toolbarSelector + " .routePlayTime").html('');

                Greenmile.Map.Utility.removeLayerByKind(map, ['TRACK_EQUIPMENT', 'EQUIPMENT', 'ARROW', 'coordDistance', 'TRACK_EVENTS', 'EVENT', 'ACTUAL_ROUTE', 'SECONDARY_ROUTE', 'SECONDARY_EQUIPMENT']);
            }
        });
    };

    this.addListeners = function () {

        this.addCoordsRange();
        this.addFormFilterListener();
    };

    this.togglePlayer = function (callPlay, callStop) {

        if (sourceData.player.isPlaying) {
            this.stopPlayer();

            if (callStop) {
                callStop();
            }

        } else {

            sourceData.player.playerIndex = 0;
            sourceData.player.lastMarkerIndex = sourceData.coordinates.size() - 1;

            if (callPlay) {
                callPlay();
            }

            if (beforeStartPlay) {
                beforeStartPlay();
            }

            this.startPlayer();

        }

        this.changePlayerIcon();
    };

    this.startPlayer = function () {

        sourceData.player.isPlaying = true;
        this.changePlayerIcon();
        this.play();

    };

    this.stopPlayer = function () {

        sourceData.player.isPlaying = false;
        this.changePlayerIcon();

    };

    this.changePlayerIcon = function () {

        if (sourceData.player.isPlaying) {
            $(_toolbarSelector + " .routePlayGo").toggleClass('routePlayGo routePlayPause');
        } else {
            $(_toolbarSelector + " .routePlayPause").toggleClass('routePlayPause routePlayGo');
        }

    };

    this.anime = function () {

        var screen = sourceData;
        var routePlay = this;
        var canContinue = true;

        var work = function (screen, canContinue, routePlay) {
            return function () {
                if (screen.player.playerIndex <= screen.player.lastMarkerIndex) {
                    canContinue = routePlay.goTo();
                    if (canContinue) {
                        routePlay.anime();
                    } else {
                        routePlay.stopPlayer();
                    }
                    screen.player.playerIndex += 1;
                } else {
                    routePlay.stopPlayer();
                }
            };
        }(screen, canContinue, routePlay);

        if (screen.player.isPlaying) {
            setTimeout(function () {
                work();
            }, 1000);
        }

    };

    this.play = function (frame) {

        if (frame) {
            sourceData.player.currentMarkerIndex = frame;
        }

        this.anime();
    };

    this.goTo = function () {

        var screen = sourceData;
        var map = screen.map;

        if (screen.coordinates) {

            var coord = null;
            var fullDate;

            if (screen.coordinates.size()) {
                const coordinates = screen.coordinates;
                if (coordinates.at(screen.player.playerIndex)) {
                    coord = coordinates.at(screen.player.playerIndex).attributes;
                } else {
                    coord = null;
                }

            } else {

                coord = null;

            }

            if (coord) {

                var latlng = new L.LatLng(coord.position.latitude, coord.position.longitude);
                fullDate = coord.date;
                map.panTo(latlng);

                updateTruckPosition([latlng.lat, latlng.lng]);

                $(_toolbarSelector + " .routePlayTime").html(Monet.Format.DateTime.formatToLocale(fullDate));

            } else {
                return false;
            }

            return true;
        }

        return false;

    };

    this.setDateRangeToNamespace = function (iDate, fDate) {

        sourceData.initialDateField = iDate || sourceData.initialDateField;
        sourceData.finalDateField = fDate || sourceData.finalDateField;

        if (sourceData.player) {
            sourceData.player.playerIndex = sourceData.player.lastMarkerIndex || 0;
        }
    };

};
